// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3FqoL","errorLogs":"styles_errorLogs__1BjU9"};